import { useConditionComparatorFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionComparatorWarning = () => {
  const fieldPath = useConditionComparatorFieldPath();
  const { getHasWarningFromFieldPath } = useQueryErrorStateContext();
  const warningFromFieldPath = getHasWarningFromFieldPath(fieldPath);

  return warningFromFieldPath;
};
